import find from 'lodash/find';
import { FILTER_OPTIONS } from '../../constants';

export const getQueryFilter = (value: string) => {
  return find(FILTER_OPTIONS, { value: value })?.queryFilter;
};
